import PriorityChip from "@/features/leads/components/common/PriorityChip";
import { priorityOptions } from "@/features/leads/types/constants";
import { useState, useEffect } from "react";

export default function LeadPriority({
  callBack = () => {},
  style = {},
  defaultValue = "None",
}: any) {
  // 1. Local State for INSTANT UI feedback
  const [priority, setPriority] = useState<string>(defaultValue);

  // 2. Sync Local State if Parent's defaultValue changes (e.g., after API confirm or refresh)
  useEffect(() => {
    setPriority(defaultValue);
  }, [defaultValue]);

  const handleClick = (option: any) => {
    // 3. Update UI IMMEDIATELY (Optimistic Update)
    setPriority(option.value);

    // 4. Send request to server/parent in the background
    callBack(option.value);
  };

  return (
    <div style={style}>
      <div className="flex gap-1.5 items-center flex-wrap">
        {priorityOptions.map((option) => (
          <PriorityChip
            key={option.value}
            option={option}
            // Check against LOCAL state for instant speed
            isSelected={priority?.toLowerCase() === option.value.toLowerCase()}
            onClick={() => handleClick(option)}
          />
        ))}
      </div>
    </div>
  );
}
